goog.provide('el8.apphome.reqAct.reqActPatients');

goog.require('el8.model.base');
goog.require('el8.model.identify');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.letterReceipts');
goog.require('el8.ptdata.letters');
goog.require('el8.ptdata.ptTags');
goog.require('el8.ptdata.plrCollaboratorNotifications');
goog.require('el8.ptdata.unreadLetterNotifications');
goog.require('el8.ptdata.documentReminderNotifications');
goog.require('el8.service.tz');
goog.require('el8.template.ptdata.patients');
goog.require('el8.util.datecompare');
goog.require('el8.ptdata.directMessages');
goog.require('el8.ptdata.reports');


el8.apphome.reqAct.reqActPatients = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty('firstName');
    _class.addStringProperty('middleName');
    _class.addStringProperty('lastName');
    _class.addDate('dob', true);
    _class.addIntProperty('age');
    _class.addStringProperty('displayAge');
    _class.addStringProperty('sex');
    _class.addStringProperty('phone1');
    _class.addStringProperty('phone1Type');
    _class.addDate('lastSeenDate');
    _class.addDate('nextApptDate');
    _class.addProperty('tagIds', false, []);
    _class.addBoolean('verified');
    _class.addBoolean('vip');

    /**
     * Helpers for req act feed
     * - data holds list of id, model_class dicts of actual req act items
     */
    _class.addProperty('data');

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        spec['model_class'] = 'ReqActPatient';

        this.parent.populate.call(this, spec);
        if (spec.tags) {
          el8.ptdata.ptTags.create(spec.tags, true);
          this.setTagIds(_.pluck(spec.tags, 'id'));
        }
    };

    _class.prototype.getDisplayName = function() {
        // Re-use the display name template from patients
        return el8.template.ptdata.patients.displayName({
            firstName: this.getFirstName(),
            middleName: this.getMiddleName(),
            lastName: this.getLastName()
        }).el8_unescape();
    };

    _class.prototype.getTagValues = function() {
        return this.getTagIds().map(function(id) {
            var tag = el8.ptdata.ptTags.getById(id);
            return tag ? tag.getValue() : null;
        });
    };

    _class.prototype.getFeedInfo = function() {

        if (!this.getData()) { return {}; }
        var data = this.getData();


        var itemWithMinDate = _.min(data, function(item) {
            return el8.service.tz.toTzDateTime(item.feed_date);
        });
        var feedDate = el8.service.tz.toTzDateTime(itemWithMinDate.feed_date);

        var counts = _.countBy(data, function(item) {
            var mClass = item.report_type || item.model_class || el8.model.idToModelClass(item.id);
            if (mClass === 'VisitNote' || mClass === 'VisitNote2') { return 'Note'; }
            if (mClass === 'NonvisitNote') {
                // only if the nonvisitnote is NOT type direct, will we count it as a Note
                // keep in mind that we're also checking to see if note is defined here - according to
                // el8.apphome.reqAct.fetchFn, we're not loading nonvisitnotes from the server if
                // they are not of type DIRECT, thus it's possible that we simply won't get a result
                // here when looking up via el8.ptdata.nonvisitNotes.getById().  but if we can't find
                // a nonvisitnote in client side model, it's likely because it's on practice home and
                // that nonvisitnote is not of type DIRECT.
                var note = el8.ptdata.nonvisitNotes.getById(item.id);
                if (note && note.isTypeDirect()) {
                    return 'IncomingDirectMessage';
                } else {
                    return 'Note';
                }
            } // count notes together

            // we have a case of MedOrder where the user asks the pharmacy to cancel an
            // eRx, but the pharmacy denies their request. We're going to separate from
            // the typicall MedOrder so we can say it's a deny rather than an error
            if (mClass === 'MedOrder' && item.is_deny_cancel) {
                return 'DenyCancelMedOrder';
            }

            return mClass;
        });
        var countsArray = []; // need an array for the templates
        for (var mClass in counts) {
            if (counts.hasOwnProperty(mClass)) {
                countsArray.push({
                    modelClass: mClass,
                    count: counts[mClass]
                });
            }
        }
        // Note: we sort on the modelClass alphabetically, but sometimes the display name we use
        // (e.g., MedOrder -> failed eRx) means that the end result is not sorted alphabetically.
        // We can't use the display name to sort because it lives in the templates and is dependent
        // on which feed this index happpens to be rendering in.
        countsArray = _.sortBy(countsArray, function(dict) { return dict.modelClass; });

        return {
            feedDate: feedDate,
            counts: countsArray
        };
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        mapped['name'] = this.getDisplayName();
        mapped['phone'] = this.getPhone1();

        var feedInfo = this.getFeedInfo();
        mapped['feedDate'] = el8.service.tz.soyStr(feedInfo['feedDate']);
        mapped['modelCounts'] = feedInfo['counts'];

        delete mapped['tagIds'];
        mapped['tags'] = this.getTagValues();

        return mapped;
    };

    /**
     * These two functions are weird, but since this whole file is a kind of weird
     * model that exists to make it easier to render practice home queues and these
     * functions are only used to render portions of that queue, it makes sense to
     * add buttonsInfo directly to our "soyMaps" here */
    _class.prototype.getMessageThreadMaps = function() {
        var threads = this.getData().filter(function(item) {
            var mClass = el8.model.idToModelClass(item.id);
            return (mClass === 'MessageThread');
        });
        var maps = threads.map(function(item) {
            var thread = el8.ptdata.messageThreads.getById(item.id);
            var m = thread.asSoyMap(false);
            m['buttonsInfo'] = el8.apphome.reqAct.actions.buttons(thread);
            m['feedItemId'] = thread.getFeedItemId();
            return m;
        });
        return maps;
    };
    _class.prototype.getLetterMaps = function() {
        var letters = this.getData().filter(function(item) {
            var mClass = el8.model.idToModelClass(item.id);
            return (mClass === 'Letter');
        });
        var maps = letters.map(function(item) {
            var letter = el8.ptdata.letters.getById(item.id);
            var m = letter.asSoyMap();
            m['buttonsInfo'] = el8.apphome.reqAct.actions.buttons(letter);
            return m;
        });
        return maps;
    };
    _class.prototype.getLetterReceiptMaps = function() {
        var letterReceipts = this.getData().filter(function(item) {
            var mClass = el8.model.idToModelClass(item.id);
            return (mClass === 'LetterReceipt');
        });
        var maps = letterReceipts.map(function(item) {
            var lr = el8.ptdata.letterReceipts.getById(item.id);
            var m = lr.asSoyMap();
            m['buttonsInfo'] = el8.apphome.reqAct.actions.buttons(lr);
            return m;
        });
        return maps;
    };
    _class.prototype.getReminderNotificationMaps = function() {

        if (!el8Globals.FEATURES.BiDiLabs) {return [];}

        var documentReminderNotifications = this.getData().filter(function(item) {
            var mClass = el8.model.idToModelClass(item.id);
            return (mClass === 'DocumentReminderNotification');
        });
        var maps = documentReminderNotifications.map(function(item) {
            var notification = el8.ptdata.documentReminderNotifications.getById(item.id);
            var m = notification.asSoyMap();
            m['buttonsInfo'] = el8.apphome.reqAct.actions.buttons(notification);
            return m;
        });
        return maps;
    };
    _class.prototype.getFormsRequestNotifications = function() {
        var formsRequestNotifications = this.getData().filter(function(item) {
            return (item.model_class === 'PatientFormRequest');
        });
        return formsRequestNotifications;
    };
    _class.prototype.getUnreadLetterNotificationMaps = function() {
        var unreadLetterNotifications = this.getData().filter(function(item) {
            var mClass = el8.model.idToModelClass(item.id);
            return (mClass === 'UnreadLetterNotification');
        });
        var maps = unreadLetterNotifications.map(function(item) {
            var lr = el8.ptdata.unreadLetterNotifications.getById(item.id);
            var m = lr.asSoyMap();
            m['buttonsInfo'] = el8.apphome.reqAct.actions.buttons(lr);
            return m;
        });
        return maps;
    };
    _class.prototype.getCollaboratorNotificationMaps = function() {
        var collabNotifications = this.getData().filter(function(item) {
            var mClass = el8.model.idToModelClass(item.id);
            return (mClass === 'PatientCollaboratorNotification');
        });
        var maps = collabNotifications.map(function(item) {
            var notification = el8.ptdata.plrCollaboratorNotifications.getById(item.id);
            var m = notification.asSoyMap();
            m['buttonsInfo'] = el8.apphome.reqAct.actions.buttons(notification);
            return m;
        });
        return maps;
    };
    _class.prototype.getDirectMessageMaps = function() {
        var directMessages = this.getData().filter(function(item) {
            var mClass = el8.model.idToModelClass(item.id);
            return (mClass === 'IncomingDirectMessage') ||
                   (mClass === 'NonvisitNote');
        });

        var maps = [];
        directMessages.forEach(function(item) {
            var mClass = el8.model.idToModelClass(item.id);
            if (mClass === 'IncomingDirectMessage') {
                var msg = el8.ptdata.directMessages.getById(item.id);
                var m = msg.asSoyMap();
                m['buttonsInfo'] = el8.apphome.reqAct.actions.buttons(msg);
                maps.push(m);

            } else if (mClass === 'NonvisitNote') {
                var note = el8.ptdata.nonvisitNotes.getById(item.id);
                // only if the nonvisitnote is type direct, will we include it as a direct message
                // keep in mind that we're also checking to see if note is defined here - according to
                // el8.apphome.reqAct.fetchFn, we're not loading nonvisitnotes from the server if
                // they are not of type DIRECT, thus it's possible that we simply won't get a result
                // here when looking up via el8.ptdata.nonvisitNotes.getById().  but if we can't find
                // a nonvisitnote in client side model, it's likely because it's on practice home and
                // that nonvisitnote is not of type DIRECT.
                if (note && note.isTypeDirect()) {
                    var m = note.asSoyMap();
                    m['fromAddress'] = m['associatedEmail']['from_email'];
                    m['subject'] = m['associatedEmail']['subject'];
                    m['buttonsInfo'] = el8.apphome.reqAct.actions.buttons(note);
                    maps.push(m);
                }
            }
        });
        return maps;
    };
    _class.prototype.getReportMaps = function() {
        var reports = this.getData().filter(function(item) {
            var mClass = el8.model.idToModelClass(item.id);
            return (mClass === 'Report');
        });
        var maps = reports.map(function(item) {
            var report = el8.ptdata.reports.getById(item.id);
            var m = report.asSoyMap();
            return m;
        });
        return maps;
    };

    /**
     * Remove a message thread or letter from the reqActPatient's data dict */
    _class.prototype.removeDataItem = function(idToRemove) {
        var data = this.getData();
        for (var i=0; i<data.length; i++) {
            if (data[i].id === idToRemove) {
                data.splice(i, 1);
            }
        }
        this.setData(data);
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); }
    });

    return that;

})();

